import src from '/Users/huynhducduy/workspace/innosearch/innosearch-fe/interface/src/assets/homepage/hero-background.jpeg?url';

export default {
  lqip: `data:image/jpeg;base64,UklGRrYAAABXRUJQVlA4IKoAAABQBgCdASogABIAPmUmj0WkIiEb/VQAQAZEsgBOmUI8z9Nu57QQbfy/5gAAsXa7Ev1NQbIMjV+zc/5rAAD++cdwM4N37Oqg+8s3//1wp08+gjkX0+gMpHr9piQc5b9Kh36hh45+w4dOU/t58ME0bm2eF04jNI/gY40GFriLRwUtK1Tl1bo2tfLiJi8qa2qxH5/1ipNRbfox1HaaG33Ir3a/ckv4NOPDlaaAAA==`,
  src,
  width: 3840,
  height: 2160,
};
			